import {
  REQUEST_CONTINENTS, RECEIVE_CONTINENTS, RECEIVE_CONTINENT,
} from '../actions/continents';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_CONTINENTS:
      return { ...state, loading: true };
    case RECEIVE_CONTINENTS:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_CONTINENT:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
